import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { licenseEndOfGracePeriodSelector } from '@lumapps/customer/ducks/selectors';
import { CUSTOMER } from '@lumapps/customer/keys';
import { Kind, Message } from '@lumapps/lumx/react';
import { useSelector } from '@lumapps/redux/react';
import { useTranslate } from '@lumapps/translations';
import { getDifferenceInDays } from '@lumapps/utils/date/getDatesDifference';

import './index.scss';

const CLASSNAME = 'grace-period-banner';

/**
 * Displays a warning banner at the bottom of the screen when the customer license is in the grace period,
 * indicating the number of days remaining before permanent deletion.
 */
export const GracePeriodBanner = () => {
    const { translateAndReplaceWithComponents, translateAndReplace } = useTranslate();
    const { block } = useClassnames(CLASSNAME);

    const licenseEndOfGracePeriod = useSelector(licenseEndOfGracePeriodSelector);

    if (!licenseEndOfGracePeriod) {
        return null;
    }

    const daysRemaining = getDifferenceInDays(new Date(), new Date(licenseEndOfGracePeriod));

    const licenseDelayTranslated = translateAndReplace(CUSTOMER.LICENSE_GRACE_PERIOD_DELETION_DELAY, {
        DAYS: daysRemaining,
    });

    return (
        <div className={block()}>
            <Message kind={Kind.error} hasBackground>
                {translateAndReplaceWithComponents(CUSTOMER.GRACE_PERIOD_WARNING, {
                    DETAILS: <strong>{licenseDelayTranslated}</strong>,
                })}
            </Message>
        </div>
    );
};
